<script lang="ts">
  // Libs
  import { pluralize } from "@shared/svelte/Modules/pluralize";

  // Components
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";

  // Stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // Props
  export let distributorCount: number = 0;
  export let itemCount: number = 0;

  $: distributorCountText = pluralize("distributor", distributorCount, true);
  $: itemCountText = pluralize("items", itemCount, true);
</script>

<div
  class="fizz-surface fizz-flex-row fizz-justify-center"
  class:fizz-inset-squish-16={$layoutStore.isMobile}
  class:fizz-inset-squish-24={$layoutStore.isDesktop}
>
  <div class="fizz-flex-item" style="max-width:1440px">
    <div class="fizz-flex-row fizz-justify-center">
      <div
        class="fizz-flex-item fizz-flex-row fizz-space-between"
        class:fizz-inset-horizontal-32={$layoutStore.isDesktop}
      >
        <div class="fizz-flex-row fizz-flex-item">
          <h3 class="fizz-heading-3">Cart</h3>
          {#if distributorCount > 0 && itemCount > 0 && $layoutStore.isDesktop}
            <p data-testid="cart-header-counts">
              {distributorCountText} · {itemCountText}
            </p>
          {/if}
        </div>
        <div><ChatWithSupportLink message={"Need help?"} /></div>
      </div>
    </div>
  </div>
</div>
